import React from 'react';
import {Link, Image} from '@shopify/hydrogen';
import clsx from 'clsx';
import * as R from 'ramda';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Popover} from '@headlessui/react';
import {CurrencyCode as CurrencyCodeType} from '@shopify/hydrogen/storefront-api-types';
import {withCookies} from 'react-cookie';

//types
import type {BFSProductType} from '../../types';
import type {Cookies as CookiesType} from 'react-cookie';

//utils
import formatCurrency from '../../utils/formatCurrency.client';

//context
import {GlobalContext} from '../../GlobalProvider.client';
//TODO: blogs now at CMS, not at Shopify
//TODO: collections page url not right from search results: example, scorpion = /pages/scorpion, not /collections/scorpion

//BFS Search Types
interface SearchResult {
  all_empty: boolean;
  collections: {
    body_html: string;
    handle: string;
    id: number;
    image: {
      alt: string;
      created_at: string;
      height: number;
      src: string;
      width: number;
    };
    template_suffix: string;
    title: string;
  }[];
  did_you_mean: string[];
  event_type?: string;
  pages: {
    body_html: string;
    handle: string;
    id: number;
    template_suffix: string;
    title: string;
    url: string;
  }[];
  products: BFSProductType[];
  query: string;
  suggestions: string[];
  total_product: number;
}

interface SearchaniseProduct {
  product_id: string;
  title: string;
  description: string;
  link: string;
  price: string;
  list_price: string;
  quantity: string;
  product_code: string;
  image_link: string;
  vendor: string;
  discount: string;
  add_to_cart_id: string;
  shopify_variants: {
    variant_id: string;
    sku: string;
    barcode: string;
    price: string;
    list_price: string;
    taxable: string;
    options: {
      Colour: string;
      Size: string;
    };
    available: string;
    search_variant_metafields_data: any;
    filter_variant_metafields_data: any;
    image_link: string;
    image_alt: string;
    quantity_total: string;
    link: string;
    shopify_images: string[];
    shopify_images_alt: string[];
    tags: string[];
  }[];
}
interface SearchaniseSearchResult {
  totalItems: number;
  startIndex: number;
  itemsPerPage: number;
  currentItemCount: number;
  categoryStartIndex: number;
  totalCategories: number;
  pageStartIndex: number;
  totalPages: number;
  correctedQuery: string;
  suggestions: string[];
  items: SearchaniseProduct[];
  categories: {
    category_id: string;
    title: string;
    link: string;
    image_link: '';
  }[];
}

function Search({cookies}: {cookies: CookiesType}) {
  // const [results, setResults] = React.useState<SearchResult | null>(null);
  const selectedCurrency =
    (cookies.get('hk-currency') as CurrencyCodeType) ??
    ('HKD' as CurrencyCodeType);

  const currency = React.useContext(GlobalContext);
  const selectedCurrencyDetails = currency?.all_currencies?.find(
    (c) => c.currency === selectedCurrency,
  );

  const [searchaniseResults, setSerachaniseResults] =
    React.useState<SearchaniseSearchResult | null>(null);
  const [query, setQuery] = React.useState<string>('');

  async function searchSearchanise(searchQuery: string) {
    // &restrictBy[quantity]=1|
    const searchURL = `https://searchserverapi.com/getresults?api_key=9j4A1E7b2u&q=${searchQuery}&maxResults=100&startIndex=0&items=true&pages=true&categories=true&suggestions=true&vendors=false&tags=false&pageStartIndex=0&pagesMaxResults=50&categoryStartIndex=0&categoriesMaxResults=5&suggestionsMaxResults=10&translationLanguage=zh-TW&vendorsMaxResults=5&tagsMaxResults=5&output=jsonp`;
    const res = await fetch(searchURL);
    const data = await res.json();
    setSerachaniseResults(data);
  }
  // X-LITE X-803 RS ULTRA CARBON HOLESHOT

  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  return (
    <div
      className={clsx(
        'relative w-full overflow-y-scroll md:h-auto md:overflow-visible',
        isOpen && query ? 'h-screen' : 'h-auto',
      )}
      onFocus={() => setIsOpen(true)}
    >
      <div
        className={clsx([
          'absolute top-0 left-0 h-full w-screen bg-black bg-opacity-20 md:fixed md:left-1/2 md:h-screen md:-translate-x-1/2 md:bg-transparent',
          isOpen ? 'md:visible' : 'md:invisible',
          isOpen && query ? 'visible' : 'invisible',
        ])}
        onClick={() => setIsOpen(false)}
      ></div>
      <div className="fixed z-[100] flex w-full items-center space-x-2 bg-white px-5 pt-[36px] pb-2 md:relative md:py-0 md:px-0">
        <div className="relative z-10 flex w-full items-center border-[1px] border-solid border-black md:w-full">
          <input
            type="text"
            className="text-xs md:text-sm w-full flex-1 px-2 py-1 md:py-2 md:px-4 outline-none placeholder:font-normal placeholder:text-black md:w-auto"
            placeholder="Search this site..."
            onChange={async (e) => {
              setQuery(e.target.value);
              if (e.target.value) {
                await searchSearchanise(e.target.value);
              }
            }}
            value={query}
          />
          <button className="absolute right-0 top-0 hidden h-full w-[60px] items-center justify-center bg-hk-orange md:flex">
            <svg
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              clipRule="evenodd"
            >
              <path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5z" />
            </svg>
          </button>
        </div>
        {isOpen && query && (
          <button className="md:hidden" onClick={() => setIsOpen(false)}>
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 9.35849L1.85849 15L0 13.1415L5.64151 7.5L0 1.85849L1.85849 0L7.5 5.64151L13.1415 0L15 1.85849L9.35849 7.5L15 13.1415L13.1415 15L7.5 9.35849Z"
                fill="black"
              />
            </svg>
          </button>
        )}
      </div>
      <div
        className={clsx([
          'absolute top-0 z-10 h-auto w-full bg-white pt-[42.6px] md:top-full md:left-1/2 md:max-h-[500px] md:w-[200%] md:-translate-x-1/2 md:translate-y-4 md:overflow-y-scroll md:border md:shadow-md lg:w-auto lg:min-w-[800px]',
          isOpen && query ? 'visible opacity-100' : 'invisible opacity-0',
        ])}
      >
        <div className="grid gap-4 p-4 pb-40 md:grid-cols-3 md:pb-4">
          <div className="md:col-span-1">
            {searchaniseResults?.categories &&
              !R.isEmpty(searchaniseResults?.categories) && (
                <div className="mb-8">
                  <header className="mb-2 ml-2 border-b border-solid pb-1">
                    <h4 className="text-sm uppercase">Suggestions</h4>
                  </header>
                  <ul className="grid">
                    {searchaniseResults?.suggestions.map((suggestion) => {
                      return (
                        <li key={`${suggestion}`} className="">
                          <button
                            className="block p-2 text-sm font-normal"
                            onClick={async () => {
                              setQuery(suggestion);
                              await searchSearchanise(suggestion);
                            }}
                          >
                            {suggestion}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            <div className="mb-8" onClick={() => setIsOpen(false)}>
              <header className="mb-2 ml-2 border-b border-solid pb-1">
                <h4 className="text-sm uppercase">Categories</h4>
              </header>
              <ul className="grid">
                {searchaniseResults?.categories &&
                !R.isEmpty(searchaniseResults?.categories) ? (
                  searchaniseResults?.categories.map((collection) => {
                    return (
                      <li key={`${collection.category_id}`} className="">
                        <Link
                          to={`${collection.link}`}
                          className="block p-2 text-sm font-normal hover:bg-slate-300 hover:bg-opacity-20"
                        >
                          {collection.title}
                        </Link>
                      </li>
                    );
                  })
                ) : (
                  <div className="p-2 text-sm font-normal">
                    No categories were found
                  </div>
                )}
              </ul>
            </div>
            {/* TODO: get search results from sanity, page, blogs */}
          </div>
          <div className="md:col-span-2" onClick={() => setIsOpen(false)}>
            <div className="">
              <header className="mb-2 ml-2 border-b border-solid pb-1">
                <h4 className="uppercaase text-sm">Products</h4>
              </header>
              <ul className="">
                {searchaniseResults?.items &&
                !R.isEmpty(searchaniseResults.items) ? (
                  searchaniseResults.items.map((product) => {
                    return (
                      <li
                        key={product.product_id}
                        className="px-4 py-2 hover:bg-slate-300 hover:bg-opacity-20"
                      >
                        <Link to={`${product.link}`}>
                          <div className="flex space-x-4">
                            <div className="">
                              {product.image_link && product.image_link && (
                                <Image
                                  data={{
                                    url: product.image_link,
                                    altText: product.title,
                                  }}
                                  width={100}
                                  height={100}
                                />
                              )}
                            </div>
                            <div className="flex-1">
                              <h5 className="line-clamp-1text-sm font-normal">
                                {product.title}
                              </h5>
                              {product.quantity === '0' && (
                                <span className="text-xs">{`[Out Of Stock]`}</span>
                              )}
                              <p className="line-clamp-3 mt-2 text-xs font-light">
                                {product.description}
                              </p>
                              <div className="mt-2 text-sm">
                                {
                                  selectedCurrencyDetails?.details?.currency
                                    ?.symbol
                                }
                                {formatCurrency({
                                  currencyCode: selectedCurrency,
                                  amount: product.price,
                                })?.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  })
                ) : (
                  <div className="p-2 text-sm font-normal">
                    No products were found
                  </div>
                )}
                {/* {results?.products && !R.isEmpty(results.products) ? (
                  results.products.map((product) => {
                    return (
                      <li
                        key={product.id}
                        className="px-4 py-2 hover:bg-slate-300 hover:bg-opacity-20"
                      >
                        <Link to={`/products/${product.handle}`}>
                          <div className="flex space-x-4">
                            <div className="">
                              {product.images && product.images?.['1'] && (
                                <Image
                                  data={{
                                    url: product.images?.['1'],
                                    altText: product.title,
                                  }}
                                  width={100}
                                  height={100}
                                />
                              )}
                            </div>
                            <div className="flex-1">
                              <h5 className="line-clamp-1 mb-2 text-sm font-normal">
                                {product.title}
                              </h5>
                              <p className="line-clamp-3 text-xs font-light">
                                {product.body_html}
                              </p>
                              <div className="mt-2 text-sm">
                                ${product.price_min}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  })
                ) : (
                  <div className="p-2 text-sm font-normal">
                    No products were found
                  </div>
                )} */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withCookies(Search);
